// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "范彬",
        "week": "6,8,10,12,14,16周",
        "add": "实训楼C座312"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "范彬",
        "week": "7,9,11,13,15周",
        "add": "实训楼C座312"
      }
    ],
    0,
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[05-06节]）"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "大学英语（一）",
      "tec": "辛会元",
      "week": "6-16,18周",
      "add": "207国教"
    },
    {
      "sub": "高等数学（一）",
      "tec": "张娇",
      "week": "6-16,18周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "英语听说（一）",
      "tec": "外教9",
      "week": "6-16,18周",
      "add": "（6-16,18周[05-06节]）"
    },
    {
      "sub": "军事理论",
      "tec": "于瑶",
      "week": "6-13,15周",
      "add": "教学楼C座214教务"
    },
    0
  ],
  "3": [
    {
      "sub": "高等数学（一）",
      "tec": "张娇",
      "week": "6-16,18周",
      "add": "教学楼C座213教务"
    },
    0,
    0,
    [
      {
        "sub": "健康教育",
        "tec": "赵杨子",
        "week": "6-16周",
        "add": "教学楼C座212教务"
      },
      {
        "sub": "健康教育",
        "tec": "赵杨子",
        "week": "17周",
        "add": "教学楼C座212教务"
      },
      {
        "sub": "健康教育",
        "tec": "赵杨子",
        "week": "17周",
        "add": "教学楼C座212教务"
      }
    ],
    {
      "sub": "形势与政策",
      "tec": "祝嘉悦",
      "week": "6-9周",
      "add": "教学楼C座215教务"
    }
  ],
  "4": [
    {
      "sub": "心理健康与调适",
      "tec": "吴世鑫",
      "week": "6-15周",
      "add": "教学楼C座215教务"
    },
    {
      "sub": "人工智能与计算思维",
      "tec": "范彬",
      "week": "7,9,11,13,15周",
      "add": "实训楼C座308"
    },
    {
      "sub": "大学英语（一）",
      "tec": "辛会元",
      "week": "6-16,18周",
      "add": "实训楼E座310"
    },
    {
      "sub": "就业创业指导",
      "tec": "孙笑雨",
      "week": "6-10周",
      "add": "教学楼C座214教务"
    },
    0
  ],
  "5": [
    {
      "sub": "电气工程导论",
      "tec": "邹全平",
      "week": "6-13周",
      "add": "教学楼C座302教务"
    },
    {
      "sub": "高等数学（一）",
      "tec": "张娇",
      "week": "6-16,18周",
      "add": "教学楼C座111教务"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
